import { variantApi } from "./variant";

export const { useVariantBySkuQuery, useVariantsByIdQuery } = variantApi;
